import * as CustomerAPI from '@/api/system/customer';

export default {
  data() {
    return {
      // 所属客户
      customerList: [],
      currentCustomer: null,
    };
  },

  methods: {
    // 获取当前用户所有客户列表
    getAllCustomerList() {
      const params = {};
      return CustomerAPI.CustomerSelect(params).then(res => {
        if (res.code === 0) {
          this.customerList = res.data || [];
        }
      });
    },

    getCurrentCustomer(id) {
      if (id && this.customerList && this.customerList.length) {
        this.currentCustomer = this.customerList.find(item => item.customerId === id);
      } else {
        this.currentCustomer = null;
      }
    },
  },
};
